import { ApolloClient, createHttpLink, from } from '@apollo/client'
import { ErrorLink } from '@apollo/client/link/error'
import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { cache } from '@cache'
import User from '@utils/storage/user'
import { storeReturnUrl } from '@utils/auth/returnUrl'

// Apollo Client 4.x delivers a single `error` to the ErrorLink callback.
// Server-side GraphQL errors are wrapped in CombinedGraphQLErrors, whose
// `errors` array carries the `extensions` (including our UNAUTHORIZED code).
// Network/HTTP errors arrive as other error types without that array.
const errorLink = new ErrorLink(({ error }) => {
  if (CombinedGraphQLErrors.is(error)) {
    error.errors.forEach(({ message, extensions, locations, path }) => {
      console.warn(
        `[GraphQL error]: Message: ${message},`,
        `Extensions: ${extensions},`,
        `Location: ${locations},`,
        `Path: ${path}`
      )

      if (extensions?.code === 'UNAUTHORIZED') {
        User.clear()
        storeReturnUrl()

        window.location.assign('/login')
      }
    })
  } else if (error) {
    console.warn(`[Network error]: ${error.message}`)
  }
})

const httpLink = createHttpLink({
  uri: Settings.GRAPHQL_ENDPOINT,
  credentials: 'include'
})

const apolloClient = new ApolloClient({
  cache,
  link: from([errorLink, httpLink])
})

export default apolloClient
